import { render, staticRenderFns } from "./ShareContactInput.vue?vue&type=template&id=36a2c2b2"
import script from "./ShareContactInput.vue?vue&type=script&lang=ts"
export * from "./ShareContactInput.vue?vue&type=script&lang=ts"
import style0 from "./ShareContactInput.vue?vue&type=style&index=0&id=36a2c2b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports